
let timer = null ;

export default class utils {

  /**
   * 格式化时间
   * @param {*} date date对象
   * @param {*} hideTime 是否隐藏时分秒
   */
  static formatTime = (date, hideTime) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    return [year, month, day].map(utils.formatNumber).join('-') + (hideTime ? '' : (' ' + [hour, minute, second].map(utils.formatNumber).join(':')));
  };

  /**
   * format
   * @param unFormatDate 未格式化的date ，可以是date 也可以是字符串
   * @param {*} format 格式后的格式
   */
  static formatStringDate = (unFormatDate, format = 'yyyy-MM-dd') => {
    let d = unFormatDate instanceof Date ? unFormatDate : Date.parse(unFormatDate) ;
    const date = new Date(d);
    format = format.replace('yyyy', date.getFullYear() + '');
    format = format.replace('MM', utils.formatNumber(date.getMonth() + 1));
    format = format.replace('dd', utils.formatNumber(date.getDate()));
    const hour = date.getHours();
    format = format.replace('HH', utils.formatNumber(hour));
    format = format.replace('hh', utils.formatNumber(hour > 12 ? hour - 12 : hour));
    format = format.replace('mm', utils.formatNumber(date.getMinutes()));
    format = format.replace('ss', utils.formatNumber(date.getSeconds()));
    return format;
  };

  /**
   * 转换时间显示方式
   * @param stringDate
   * @returns {*}
   */
  static formatTimeToLately = stringDate => {
    const nowDate = new Date();
    const date = new Date(Date.parse(stringDate));
    if (nowDate.getFullYear() === date.getFullYear()
      && nowDate.getMonth() === date.getMonth()
      && nowDate.getDate() === date.getDate()) {
      return utils.formatStringDate(stringDate, 'HH:mm');
    }
    if (nowDate.getFullYear() === date.getFullYear()) return utils.formatStringDate(stringDate, 'MM-dd');
    return utils.formatStringDate(stringDate, 'yyyy-MM-dd');
  };


  static formatNumber = n => {
    n = n.toString();
    return n[1] ? n : '0' + n;
  };

  /**
   * 防抖函数
   * @param fn 方法
   * @param wait 时间
   * @returns {*}
   */

  static antiShake = function(fn , wait){
    if(typeof  fn !== 'function')return () => console.log('\'fn\' is not a function');
    return function () {
      if(timer !== null){
        clearTimeout(timer);
        timer = null ;
      }
      timer = setTimeout(fn , wait) ;
    }
  } ;
};




// WEBPACK FOOTER //
// ./src/assets/js/utils.js